var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.checkStrictly')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.checkStrictly),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "checkStrictly", $$v)
      },
      expression: "optionModel.checkStrictly"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bec90260","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/field-cascader/checkStrictly-editor.vue
// module id = null
// module chunks = 